import Reveal from "./Reveal";

export const Section = ({ children, className = "", tone = "sand", id }) => {
  const bg = tone === "navy" ? "bg-navy text-white" : tone === "white" ? "bg-white" : "bg-sand";
  return (
    <section id={id} className={`relative ${bg} ${className}`}>
      <div className="mx-auto max-w-7xl px-5 lg:px-10 py-16 lg:py-24">{children}</div>
    </section>
  );
};

export const SectionHeading = ({ eyebrow, title, intro, tone = "dark" }) => (
  <Reveal className="max-w-2xl">
    {eyebrow && <p className={`eyebrow ${tone === "light" ? "text-lake" : "text-lake"}`}>{eyebrow}</p>}
    <h2
      className={`mt-3 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight ${
        tone === "light" ? "text-white" : "text-navy"
      }`}
    >
      {title}
    </h2>
    {intro && (
      <p className={`mt-4 text-base leading-relaxed ${tone === "light" ? "text-white/80" : "text-slate-700"}`}>
        {intro}
      </p>
    )}
  </Reveal>
);

/** Image + copy split panel with an explicit aspect ratio (no layout shift). */
export const SplitFeature = ({ image, alt, eyebrow, title, children, reverse = false, testId }) => (
  <div
    data-testid={testId}
    className={`grid items-center gap-10 lg:gap-16 lg:grid-cols-2 ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}
  >
    <Reveal className="overflow-hidden rounded-3xl border border-sand-border bg-sand-card">
      <img
        src={image}
        alt={alt}
        loading="lazy"
        width={1264}
        height={848}
        className="h-full w-full object-cover"
        style={{ aspectRatio: "3 / 2" }}
      />
    </Reveal>
    <Reveal delay={90}>
      {eyebrow && <p className="eyebrow text-lake">{eyebrow}</p>}
      <h2 className="mt-3 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-navy">{title}</h2>
      <div className="mt-5 space-y-4 text-base leading-relaxed text-slate-700">{children}</div>
    </Reveal>
  </div>
);

export const InfoCard = ({ icon: Icon, title, children, testId }) => (
  <Reveal
    data-testid={testId}
    className="rounded-2xl border border-sand-border bg-white p-6 transition-shadow hover:shadow-lg hover:shadow-navy/5"
  >
    {Icon && (
      <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-lake/10">
        <Icon className="h-5 w-5 text-lake" aria-hidden="true" />
      </span>
    )}
    <h3 className="mt-4 font-display text-xl font-semibold text-navy">{title}</h3>
    <div className="mt-3 text-sm leading-relaxed text-slate-700">{children}</div>
  </Reveal>
);

export default Section;
